<template>
    <div
        class="relative flex flex-col min-w-0 break-words bg-white shadow-soft-xl rounded-2xl bg-clip-border"
        :class="cClass">
        <div class="flex-auto p-2">
            <div class="h-full flex">
                <div class="w-full h-full flex flex-col flex-1">
                    <div class="flex items-center justify-between">
                        <div
                            v-if="iconName"
                            class="h-16 w-16 place-items-center opacity-70">
                            <slot name="icon">
                                <component
                                    :is="iconName"
                                    v-if="iconName"
                                    class="w-16 h-16" />
                            </slot>
                        </div>
                        <div>
                            <slot name="header">
                                <p class="mb-0 font-sans font-semibold leading-normal text-base text-right">
                                    {{ text }}
                                </p>
                                <p
                                    v-if="prefixText"
                                    class="mb-0 font-sans font-semibold leading-normal text-base text-right">
                                    {{ prefixText }}
                                </p>
                            </slot>
                        </div>
                    </div>
                    <div class="flex-none w-full max-w-full px-3 flex justify-end">
                        <div>
                            <h5 class="mb-0 font-bold text-4xl max-w-4xl">
                                {{ value }}
                            </h5>
                        </div>
                    </div>
                    <slot name="filter" />
                    <slot />
                </div>
            </div>
        </div>
    </div>
    <!--  <div class="relative flex flex-col bg-clip-border rounded-xl text-gray-700 shadow-md" :class="cClass"> -->
    <!--    <div class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr shadow-lg absolute -mt-4 grid h-16 w-16 place-items-center"> -->
    <!--      &lt;!&ndash; icon &ndash;&gt; -->
    <!--      <slot name="icon"> -->
    <!--        <component :is="iconName" v-if="iconName" class="w-16 h-16" :class="{[cIconStyle]: true}" /> -->
    <!--        <svg -->
    <!--          v-else -->
    <!--          xmlns="http://www.w3.org/2000/svg" -->
    <!--          viewBox="0 0 24 24" -->
    <!--          fill="currentColor" -->
    <!--          aria-hidden="true" -->
    <!--          class="w-6 h-6 text-white" -->
    <!--        > -->
    <!--          <path d="M12 7.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" /> -->
    <!--          <path -->
    <!--            fill-rule="evenodd" -->
    <!--            d="M1.5 4.875C1.5 3.839 2.34 3 3.375 3h17.25c1.035 0 1.875.84 1.875 1.875v9.75c0 1.036-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 14.625v-9.75zM8.25 9.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM18.75 9a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75h-.008zM4.5 9.75A.75.75 0 015.25 9h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75V9.75z" -->
    <!--            clip-rule="evenodd" -->
    <!--          /> -->
    <!--          <path d="M2.25 18a.75.75 0 000 1.5c5.4 0 10.63.722 15.6 2.075 1.19.324 2.4-.558 2.4-1.82V18.75a.75.75 0 00-.75-.75H2.25z" /> -->
    <!--        </svg> -->
    <!--      </slot> -->
    <!--    </div> -->

    <!--    <div class="p-4 pl-24 text-right"> -->
    <!--      <p class="block antialiased text-lg font-medium leading-tight text-blue-gray-600"> -->
    <!--        {{ text }} -->
    <!--      </p> -->
    <!--      <slot> -->
    <!--        <h4 class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900"> -->
    <!--          {{ value }} -->
    <!--        </h4> -->
    <!--      </slot> -->
    <!--    </div> -->

    <!--    <slot name="footer"> -->
    <!--      <div v-if="typeof footerValue === 'number' || footerValue || footerText" class="border-t border-blue-gray-50 p-4"> -->
    <!--        <p class="block antialiased font-sans text-base leading-relaxed font-normal text-blue-gray-600"> -->
    <!--          <strong :class="{'text-green-500': increase, 'text-error-500': !increase}">{{ footerValue }}</strong>&nbsp;{{ footerText }} -->
    <!--        </p> -->
    <!--      </div> -->
    <!--    </slot> -->
    <!--  </div> -->
</template>
<script setup lang="ts">
import { useSlots } from 'vue'

const props = defineProps({
  value: [String, Number],
  text: String,
  iconName: String,
  iconStyle: String,
  increase: Boolean,
  color: String,
  footerValue: [String, Number],
  footerText: String,
  prefixText: String
})

const { iconStyle } = toRefs(props)

const { color } = toRefs(props)

const slots = useSlots()
const hasSlotDefault = computed(() => {
  return slots && slots.default && slots.default()
})

const cIconStyle = computed(() => iconStyle?.value)

const cClass = computed(() => {
  switch (color?.value) {
  case 'success':
    return 'bg-gradient-to-r from-green-600 to-green-400 text-white shadow-green-500/40'
  case 'error':
    return 'bg-gradient-to-r from-error-600 to-error-400 text-white shadow-error-500/40'
  case 'warning':
    return 'bg-gradient-to-r from-warning-600 to-warning-400 text-white shadow-warning-500/40'
  case 'secondary':
    return 'bg-gradient-to-r from-secondary-600 to-secondary-400 text-white shadow-secondary-500/40'
  case 'accent':
    return 'bg-gradient-to-r from-accent-600 to-accent-400 text-white shadow-accent-500/40'
  case 'neutral':
    return 'bg-gradient-to-r from-neutral-600 to-neutral-400 text-white shadow-neutral-500/40'
  case 'info':
    return 'bg-gradient-to-r from-info-600 to-info-400 text-white shadow-info-500/40'
  case 'gray':
    return 'bg-gradient-to-r from-gray-400 to-gray-300 text-white shadow-gray-500/40'
  default:
    return 'bg-gradient-to-r from-blue-600 to-blue-400 text-white shadow-blue-500/40'
  }
})
</script>
